import { useState, useEffect } from "react";
import PlaylistInput from "./PlaylistInput";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../Firebase";
import { v4 as uuidv4 } from "uuid";
import { songLists, songs } from "../assets/songs/songs";
import { FaPlus, FaTimes } from "react-icons/fa";

const AddNewSong = ({ newSongs, setNewSongs, isOpen, onClose }) => {
    const [title, setTitle] = useState("");
    const [artist, setArtist] = useState("");
    const [text, setText] = useState("");
    const [songID, setSongID] = useState("");
    const [errors, setErrors] = useState({});

    useEffect(() => {
        //Generate unique id for song
        let newSongID = uuidv4();
        setSongID(newSongID);
    }, []);

    const validateText = (value) => {
        const newErrors = {};

        // Check for commas and dots
        if (value.includes(",") || value.includes(".")) {
            newErrors.text = "Teksten kan ikke inneholde komma eller punktum.";
            return newErrors;
        }

        // Check word count
        const words = value
            .trim()
            .split(/\s+/)
            .filter((word) => word.length > 0);
        if (words.length > 0 && words.length !== 5 && words.length !== 6) {
            newErrors.text = `Teksten må inneholde nøyaktig 5 eller 6 ord. (Du har ${words.length} ord)`;
            return newErrors;
        }

        return newErrors;
    };

    const handleTextChange = (e) => {
        const value = e.target.value;
        setText(value);

        // Clear error when user starts typing
        if (errors.text) {
            setErrors({ ...errors, text: "" });
        }

        // Validate on change
        const validationErrors = validateText(value);
        if (Object.keys(validationErrors).length > 0) {
            setErrors({ ...errors, ...validationErrors });
        } else {
            setErrors({ ...errors, text: "" });
        }
    };

    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape" && isOpen) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener("keydown", handleEsc);
            return () => document.removeEventListener("keydown", handleEsc);
        }
    }, [isOpen, onClose]);

    const addNewSong = async () => {
        const newErrors = {};

        if (!title.trim()) {
            newErrors.title = "Vennligst fyll inn sangtittel.";
        }

        if (!artist.trim()) {
            newErrors.artist = "Vennligst fyll inn artistnavn.";
        }

        const textValidation = validateText(text);
        if (Object.keys(textValidation).length > 0) {
            Object.assign(newErrors, textValidation);
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            const docRef = await addDoc(collection(db, "songs"), {
                title: title,
                artist: artist,
                text: text,
                songID: songID,
            });
            setNewSongs([
                ...newSongs,
                { title: title, artist: artist, text: text, songID: songID },
            ]);
            setTitle("");
            setArtist("");
            setText("");
            setErrors({});
            onClose(); // Close modal after successful add
        } catch (e) {
            console.error("Error adding document: ", e);
            alert(
                "Det oppstod en feil ved lagring av sangen. Vennligst prøv igjen."
            );
        }
    };

    if (!isOpen) return null;

    //   const addAllSongs = async () => {
    //     const allSongs = [];
    //     songLists.forEach((list) => {
    //       list.songs.forEach((song) => {
    //         if (!allSongs.includes(song.title)) {
    //           allSongs.push(song.title);
    //           try {
    //             const docRef = addDoc(collection(db, "songs"), {
    //               title: song.title,
    //               artist: song.artist,
    //               text: song.text,
    //               songID: uuidv4(),
    //             });
    //             console.log("Document written with ID: ", docRef.id);
    //           } catch (e) {
    //             console.error("Error adding document: ", e);
    //           }
    //         }
    //       });
    //     });
    //   };

    return (
        <>
            {/* Backdrop */}
            <div
                onClick={onClose}
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    zIndex: 1000,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* Modal */}
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        backgroundColor: "#161f33",
                        borderRadius: "0.5vh",
                        padding: "2vh",
                        width: "90%",
                        maxWidth: "500px",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        boxSizing: "border-box",
                        position: "relative",
                    }}
                >
                    {/* Close button */}
                    <div
                        onClick={onClose}
                        style={{
                            position: "absolute",
                            top: "1vh",
                            right: "1vh",
                            cursor: "pointer",
                            color: "white",
                            fontSize: 20,
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "50%",
                            transition: "background-color 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = "#2a3854";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor =
                                "transparent";
                        }}
                    >
                        <FaTimes />
                    </div>

                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            boxSizing: "border-box",
                        }}
                    >
                        <div
                            style={{
                                color: "white",
                                width: "100%",
                                textAlign: "left",
                                fontSize: 16,
                                fontWeight: 500,
                                marginBottom: "1.5vh",
                            }}
                        >
                            Legg til ny sang
                        </div>

                        <div
                            style={{
                                width: "100%",
                                marginBottom: "1vh",
                                boxSizing: "border-box",
                            }}
                        >
                            <label
                                style={{
                                    color: "white",
                                    fontSize: 13,
                                    marginBottom: "0.5vh",
                                    display: "block",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Tittel
                            </label>
                            <PlaylistInput
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                    if (errors.title)
                                        setErrors({ ...errors, title: "" });
                                }}
                                placeholder="f.eks. Stayin Alive"
                                extraStyle={{
                                    width: "100%",
                                    margin: 0,
                                    boxSizing: "border-box",
                                }}
                            />
                            {errors.title && (
                                <div
                                    style={{
                                        color: "#ef4444",
                                        fontSize: 11,
                                        marginTop: "0.3vh",
                                        textAlign: "left",
                                    }}
                                >
                                    {errors.title}
                                </div>
                            )}
                        </div>

                        <div
                            style={{
                                width: "100%",
                                marginBottom: "1vh",
                                boxSizing: "border-box",
                            }}
                        >
                            <label
                                style={{
                                    color: "white",
                                    fontSize: 13,
                                    marginBottom: "0.5vh",
                                    display: "block",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Artist
                            </label>
                            <PlaylistInput
                                placeholder="f.eks. Bee Gees"
                                value={artist}
                                onChange={(e) => {
                                    setArtist(e.target.value);
                                    if (errors.artist)
                                        setErrors({ ...errors, artist: "" });
                                }}
                                extraStyle={{
                                    width: "100%",
                                    margin: 0,
                                    boxSizing: "border-box",
                                }}
                            />
                            {errors.artist && (
                                <div
                                    style={{
                                        color: "#ef4444",
                                        fontSize: 11,
                                        marginTop: "0.3vh",
                                        textAlign: "left",
                                    }}
                                >
                                    {errors.artist}
                                </div>
                            )}
                        </div>

                        <div
                            style={{
                                width: "100%",
                                marginBottom: "1.5vh",
                                boxSizing: "border-box",
                            }}
                        >
                            <label
                                style={{
                                    color: "white",
                                    fontSize: 13,
                                    marginBottom: "0.5vh",
                                    display: "block",
                                    textAlign: "left",
                                    width: "100%",
                                }}
                            >
                                Ord bak lukene
                            </label>
                            <PlaylistInput
                                placeholder="f.eks. you can tell by the way"
                                value={text}
                                onChange={handleTextChange}
                                extraStyle={{
                                    width: "100%",
                                    margin: 0,
                                    boxSizing: "border-box",
                                }}
                            />
                            {errors.text && (
                                <div
                                    style={{
                                        color: "#ef4444",
                                        fontSize: 11,
                                        marginTop: "0.3vh",
                                        textAlign: "left",
                                    }}
                                >
                                    {errors.text}
                                </div>
                            )}
                            <div
                                style={{
                                    color: "#9ca3af",
                                    fontSize: 11,
                                    marginTop: "0.3vh",
                                    textAlign: "left",
                                    lineHeight: 1.4,
                                    maxWidth: "100%",
                                }}
                            >
                                Må være nøyaktig 5 eller 6 ord (ingen komma
                                eller punktum)
                            </div>
                        </div>

                        <div
                            onClick={addNewSong}
                            style={{
                                width: "100%",
                                backgroundColor: "#4db193",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "0.5vh",
                                cursor: "pointer",
                                padding: "1vh",
                                fontSize: 14,
                                fontWeight: 500,
                                color: "white",
                                transition: "background-color 0.2s ease",
                                boxSizing: "border-box",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                    "#3d9a7a";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                    "#4db193";
                            }}
                        >
                            <FaPlus style={{ marginRight: "0.5vh" }} />
                            Legg til sang
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddNewSong;
